import React, {forwardRef, useState} from "react"

import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

// Wrapper is `.pw-input-wrap` so the parent form's SCSS owns the input
// chrome (border, focus ring, colors) — the component just provides the
// "click to show/hide" affordance. The eye icon picks up `var(--text-...)`
// colors via the parent's CSS rules, so it themes automatically.
export const PasswordInput = forwardRef(function (props, ref) {
    const [isHidden, setIsHidden] = useState(true)
    const EyeIcon = isHidden ? VisibilityIcon : VisibilityOffIcon

    return (
        <div className={'pw-input-wrap'}>
            <input
                ref={ref}
                {...props}
                type={isHidden ? 'password' : 'text'}
            />
            <EyeIcon
                className={'pw-eye'}
                onClick={() => setIsHidden((v) => !v)}
            />
        </div>
    )
})
